import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Megaphone } from 'lucide-react';
import { Skeleton } from '@wit-support/ui';
/**
 * The campaigns screen (tree, live-edit and funnel-settings dialogs) is the
 * heavy part of the module: loaded on demand so the main bundle stays under
 * the service worker's precache limit. Never import `routes/campaigns`
 * statically from this file — that puts it back into the main chunk.
 */
const LazyCampaignsPage = lazy(() => import('./routes/campaigns.js').then((m) => ({ default: m.CampaignsPage })));
function CampaignsPageRoute() {
    return (_jsx(Suspense, { fallback: _jsxs("div", { className: "flex flex-col gap-3 p-4", "aria-busy": "true", children: [_jsx(Skeleton, { className: "h-10 w-full" }), _jsx(Skeleton, { className: "h-64 w-full" })] }), children: _jsx(LazyCampaignsPage, {}) }));
}
/**
 * Раздел «Кампании» пространства «Реклама» (контракт A2a, 03.11.2026): список
 * кампаний кабинета деревом «кампания → группы → объявления», пауза и включение
 * одного объекта и пачкой (только кампании) через admin-api
 * `/api/ads/accounts/:id/campaigns…`.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`),
 * `admin-client-core` и `admin-contracts` (ESLint allowlist). Модуль «Запуски FB»
 * НЕ импортируется: ссылки на его страницы — адреса (`/fb-launches/...`).
 * Права на действия — `AdsCampaignsModulePermsProvider` (шелл даёт флаги из
 * `me.permissions`): пауза — `ads.launch`, включение — `ads.activate`; без
 * провайдера действия закрыты (fail-closed), дубль-контроль — в admin-api.
 */
export const adsCampaignsModule = {
    id: 'campaigns',
    label: 'Кампании',
    icon: Megaphone,
    permission: 'ads.read',
    workspace: 'ads',
    order: 15,
    description: 'Кампании кабинета: найти объект, поставить на паузу, включить.',
    showInNav: true,
    sectionsPlacement: 'sidebar',
    routeChrome: 'shell',
    sections: [],
    routes: [{ path: '/', component: CampaignsPageRoute }],
};
export { setAdsCampaignsApiBaseUrl } from './api.js';
export { ADS_CAMPAIGNS_NO_PERMS, AdsCampaignsModulePermsProvider, adsCampaignsPermsFrom, useAdsCampaignsPerms, } from './perms.js';
//# sourceMappingURL=index.js.map